import React from 'react';
import { createRoot } from 'react-dom/client';

function Domainname() {
    return (
        <div id="app-bounds">
            {/*app bounds*/}
        </div>
    );
}

document.addEventListener('DOMContentLoaded', () => {
    const root = createRoot(document.getElementById('domainname'));
    root.render(<Domainname />);
});
